import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { BacnetDeviceIcon } from "./IconBacnetDevice";
import { ConfigurationPanel } from "./ConfigurationPanel";
import InsightsPanel from "./InsightsPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: BacnetDeviceIcon,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: InsightsPanel,
    ConfigurationPanel: ConfigurationPanel
}